import React from 'react'
import styled, { css } from 'styled-components'
import { useMediaQuery } from 'react-responsive'
import Box from '@components/Box'
import { SH4, STypographyDefault } from '@components/Typography'
import { IButton, SButton, SButtonHeader } from '@components/Button/Button'
import { above } from '@styles/mixins/breakpoints'
import { md, TBreakpoints } from '@styles/variables/breakpoints'

export type ICardHeight = Partial<Record<TBreakpoints | '_', string>>

export interface ICard {
  heading: string
  text: string | React.ReactNode
  icon: React.ReactNode
  number: number
  button?: IButton
  color?: string
  cardHeight?: ICardHeight
}

const SCard = styled(Box)`
  width: 100%;
  padding-left: 20px;
  flex-shrink: 0;
  flex-grow: 0;

  ${above('xl')(css`
    width: 33.333%;
  `)}
`

const SContainer = styled(Box)`
  position: relative;
  border: 1px solid #e2e6ec;
  border-radius: 8px;
  padding: 20px;
  height: 100%;

  ${above('md')(css`
    padding: 32px;
  `)}
`

const SNumber = styled.div`
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: ${({ theme }) => theme.colors.middleGray};
`

export const SWideButton = styled(SButton)`
  width: 100%;
  justify-content: center;
`

const Card: React.FC<ICard> = ({ number, heading, text, button, color = 'green', cardHeight }) => {
  const isSm = useMediaQuery({ maxWidth: md - 1 })

  const buttonProps = {
    children: 'Подробнее',
  }

  return (
    <SCard height={cardHeight}>
      <SContainer display="flex" flexDirection="column" alignItems="flex-start" height="100%">
        <SH4 mb="20px" color={color} width="100%">
          {heading}
        </SH4>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
          alignItems="flex-start"
          width="100%"
        >
          <STypographyDefault width="100%" mb={{ md: '45px' }}>
            {text}
          </STypographyDefault>
          {button &&
            (isSm ? (
              <SWideButton {...buttonProps} target="_blank" {...button} />
            ) : (
              <SButtonHeader {...buttonProps} type="black" target="_blank" {...button} />
            ))}
        </Box>
        {!isSm && <SNumber>0{number}</SNumber>}
      </SContainer>
    </SCard>
  )
}

export default Card
